import { render } from "./Culture.vue?vue&type=template&id=59b1c4cc&scoped=true"
import script from "./Culture.vue?vue&type=script&lang=js"
export * from "./Culture.vue?vue&type=script&lang=js"

import "./Culture.vue?vue&type=style&index=0&id=59b1c4cc&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59b1c4cc"]])

export default __exports__